@if (!isClosing) {
  <div #modal cdkTrapFocus
    [@slideInFromTop]
    [ngStyle]="{'width.px': width}"
    tabindex="0"
    class="ats-spotlight ats-spotlight-container"
    data-testid="spotlight">
    <form [formGroup]="form" class="flex align-items-center gap-2">
      <i class="i i-search search-icon"></i>
      <input
        #input
        class="ats-input"
        data-testid="spotlight.input"
        type="text"
        formControlName="value"
        [placeholder]="!filterValue() ? 'Enter the page title or link' : ''"/>
    </form>
    <div class="ats-spotlight-content" #resultsContainer>
      <div class="line"></div>
      @if (filteredMenuItems().length) {
        <ngx-simplebar [options]="options" class="ats-modal-content pt-2 pb-2" [style.max-height]="'395px'">
          <div #resultsContainer class="results-container" style="max-height: 370px; overflow-y: auto;">
            @if (!filterValue()) {
              <p class="ats-spotlight-title">Suggestions</p>
            }
            @for (item of filteredMenuItems(); track item.route ?? item.label; let index = $index) {
              <a [routerLink]="[item.route]" class="ats-spotlight-item" data-testid="spotlight.result" [attr.data-id]="item.id" (click)="openLink($event, item)" [ngClass]="{'selected': selectedIndex() === index}">
                @if (item.icon) {
                  <i [class]="item.icon"></i>
                } @else {
                  <p class="no-icon"></p>
                }
                <span class="ats-spotlight-item-text">
                  @if (item.parentLabel) {
                    <span class="ats-spotlight-item-path"><span [innerHTML]="highlight(item.parentLabel, filterValue())"></span> › </span>
                  }
                  <span [innerHTML]="highlight(item.label, filterValue())"></span>
                </span>
              </a>
            }
          </div>
        </ngx-simplebar>
        <div class="line bottom"></div>
        <div class="flex gap-3 align-items-center justify-content-end">
          <div class="tip">
            <div class="flex align-items-center gap-2">Open:
              <div class="key-badge"><i class="i i-enter"></i></div>
            </div>
          </div>
          <div class="divider"></div>
          <div class="tip">
            <div class="flex align-items-center gap-2">New Tab:
              <div class="key-badge"><i class="i i-cmd"></i></div>
              <div class="key-badge"><i class="i i-enter"></i></div>
            </div>
          </div>
        </div>
      } @else {
        <div class="ats-spotlight-item" data-testid="spotlight.no-results">
          <p>No results found</p>
        </div>
      }
    </div>
  </div>
}
